"use client";

import dynamic from "next/dynamic";

import Skeleton from "./skeleton";

const Registration = dynamic(() => import("./Registration"), {
  loading: () => (
    <Skeleton screenType={"MOBILE_NUMBER_EMAIL"} isMobile={true} />
  ),
});

export default Registration;
